"use client";

import { c as _c } from "react/compiler-runtime";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState, useEffect } from "react";
import styles from "./ScrollToButton.module.scss";
import { Link } from "react-scroll";
import { faChevronUp } from "@fortawesome/free-solid-svg-icons";
interface Props {
  to: string;
  threshold: number;
  offset: number;
}
export default function ScrollToButton(props) {
  const $ = _c(11);
  const [showButton, setShowButton] = useState(false);
  let t0;
  if ($[0] !== props.threshold || $[1] !== props.to) {
    t0 = () => {
      const target = document.getElementById(props.to);
      const handleScroll = function handleScroll() {
        const threshold = props.threshold + (target ? target.offsetTop : 0);
        if (window.pageYOffset > threshold) {
          setShowButton(true);
        } else {
          setShowButton(false);
        }
      };
      window.addEventListener("scroll", handleScroll);
      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    };
    $[0] = props.threshold;
    $[1] = props.to;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  useEffect(t0, t1);
  const t2 = showButton ? "flex" : "none";
  let t3;
  if ($[4] !== t2) {
    t3 = {
      display: t2
    };
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <FontAwesomeIcon icon={faChevronUp} className={styles.icon} />;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== props.offset || $[8] !== props.to || $[9] !== t3) {
    t5 = <Link className={styles.btn} activeClass="active" to={props.to} smooth={true} offset={props.offset} style={t3} duration={250}>{t4}</Link>;
    $[7] = props.offset;
    $[8] = props.to;
    $[9] = t3;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}